"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyInsurance = void 0;
const class_validator_1 = require("class-validator");
const insurance_1 = require("../general/insurance");
// * CompanyInsurance contains an array of groups and an array of employee insurances -
// which describes which groups including employees are covered by this insurance.
//
// * This holds also the information about the employee's individually agreed insurance
//
class CompanyInsurance {
    constructor(fields) {
        this.isMainAgreement = false;
        this.insurance = new insurance_1.Insurance({});
        this.groups = [];
        for (let [key, value] of Object.entries(fields)) {
            switch (key) {
                case 'insurance':
                    this.insurance = new insurance_1.Insurance(value);
                    break;
                case 'groups':
                    this.groups = value;
                    break;
                case 'id':
                    this.id = value;
                    break;
                case 'isMainAgreement':
                    this.isMainAgreement = value;
                    break;
            }
        }
    }
    addGroup(groupId) {
        this.groups.push(groupId);
    }
    removeGroup(groupId) {
        const index = this.groups.indexOf(groupId);
        if (index > -1) {
            this.groups.splice(index, 1);
        }
    }
    toJSONObject() {
        return {
            insurance: this.insurance.toJSONObject(),
            groups: this.groups,
            id: this.id,
            isMainAgreement: this.isMainAgreement,
        };
    }
    toDatabase() {
        return {
            insurance: this.insurance.toJSONObject(),
            groups: this.groups,
            isMainAgreement: this.isMainAgreement,
        };
    }
    async isValid() {
        return await (0, class_validator_1.validate)(this).then((errors) => {
            if (errors.length > 0) {
                return errors;
            }
            else {
                return null;
            }
        });
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)()
], CompanyInsurance.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)()
], CompanyInsurance.prototype, "isMainAgreement", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)({ each: true })
], CompanyInsurance.prototype, "insurance", void 0);
__decorate([
    (0, class_validator_1.IsArray)()
], CompanyInsurance.prototype, "groups", void 0);
exports.CompanyInsurance = CompanyInsurance;
